<template>
  <span>
    <span v-if="voicemail.isCustomFolder && !isOnMobile" class="ml-4 mr-1" data-testid="voicemail-folder-label">
      <v-icon class="mr-1" small>mdi-folder</v-icon>
      <span class="text-caption font-weight-light" data-testid="voicemail-folder-name">{{ folderName }}</span>
    </span>
    <v-tooltip top open-on-hover :open-delay="500">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          data-testid="voicemail-action-favorite"
          icon
          v-bind="attrs"
          v-on="on"
          :disabled="!canWriteVMsg"
          class="ml-2"
          @click="smartFavoriteSwitch(voicemail)"
        >
          <v-icon>{{ voicemail.favorite ? 'mdi-star' : 'mdi-star-outline' }}</v-icon>
        </v-btn>
      </template>
      <span>{{ voicemail.favorite ? $t('vmail.tip.removeFromFavorites') : $t('vmail.tip.addToFavorites') }}</span>
    </v-tooltip>

    <v-tooltip top open-on-hover :open-delay="500" v-if="!voicemail.isCustomFolder">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          data-testid="voicemail-action-toggle-read"
          icon
          v-bind="attrs"
          v-on="on"
          :disabled="!canWriteVMsg"
          class="ml-2"
          @click="toggleRead(voicemail.id)"
        >
          <v-icon>{{ voicemail.isRead ? 'mdi-email-open' : 'mdi-email' }}</v-icon>
        </v-btn>
      </template>
      <span>{{ voicemail.isRead ? $t('vmail.tip.markUnread') : $t('vmail.tip.markRead') }}</span>
    </v-tooltip>

    <v-tooltip top open-on-hover :open-delay="500">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          data-testid="voicemail-action-forward"
          icon
          v-bind="attrs"
          v-on="on"
          :disabled="!canWriteVMsg"
          class="ml-2"
          @click="$emit('xfer-msg', voicemail)"
        >
          <v-icon>mdi-phone-forward</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('vmail.tip.forwardVoicemail') }}</span>
    </v-tooltip>

    <v-tooltip top open-on-hover :open-delay="500">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          data-testid="voicemail-action-delete"
          icon
          v-bind="attrs"
          v-on="on"
          :disabled="!canWriteVMsg"
          class="ml-2"
          @click="$emit('del-msg', voicemail)"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('vmail.tip.deleteVoicemail') }}</span>
    </v-tooltip>

    <v-menu v-model="menuVisible" offset-y data-testid="voicemail-action-menu-wrapper">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          data-testid="voicemail-action-menu"
          v-bind="attrs"
          v-on="on"
          icon
          :disabled="!canWriteVMsg"
          class="ml-2"
        >
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list :dense="!isOnMobile">
        <v-list-item
          v-if="!voicemail.isCustomFolder"
          link
          data-testid="voicemail-move-to-custom"
          @click="$emit('move-to-custom-folder', voicemail)"
        >
          <v-icon class="mr-2" :small="!isOnMobile">mdi-folder</v-icon>
          <v-list-item-title>{{ $t('vmail.btn.moveToCustomFolder') }}</v-list-item-title>
        </v-list-item>
        <v-list-item
          v-if="voicemail.isCustomFolder"
          link
          data-testid="voicemail-remove-from-custom"
          @click="$emit('remove-from-custom-folder', voicemail)"
        >
          <v-icon class="mr-2" :small="!isOnMobile">mdi-folder-off</v-icon>
          <v-list-item-title>{{ $t('vmail.btn.removeFromCustomFolder') }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </span>
</template>
<script>

import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      menuVisible: false
    }
  },
  props: {
    voicemail: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      canWriteVMsg: 'permissions/vmailsWrite'
    }),
    isOnMobile () {
      return this.$vuetify.breakpoint.mobile
    },
    folderName () {
      return this.voicemail?.customFolder
    }
  },
  methods: {
    ...mapActions({
      toggleRead: 'voicemails/toggleRead',
      smartFavoriteSwitch: 'voicemails/smartFavoriteSwitch'
    })
  }
}
</script>

<style scoped>
</style>
